<div
  class="app-rte"
  [class.app-rte--fullscreen]="fullscreen()"
  [class.app-rte--readonly]="isLocked()"
  [attr.role]="fullscreen() ? 'dialog' : null"
  [attr.aria-modal]="fullscreen() ? 'true' : null"
  [attr.aria-label]="fullscreen() ? 'Editor em tela cheia' : null">
  @if (!readonly()) {
    <app-rich-text-editor-toolbar
      class="app-rte__toolbar"
      [formats]="formats()"
      [variables]="variables()"
      [fullscreen]="fullscreen()"
      (command)="onCommand($event)"
      (toggleFullscreen)="toggleFullscreen()" />
  }

  <div class="app-rte__canvas">
    <div class="app-rte__sheet" [style.min-height]="minHeight()">
      @if (!ready()) {
        <div class="app-rte__skeleton" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      }
      <div #editorHost class="app-rte__editor"></div>
    </div>
  </div>
</div>
